import React from "react";
import { Route, Routes } from "react-router";
import Layout from "../layouts/SupportLayout";
import { isLoggedIn } from "../helpers/api/authService";
import { Users } from "../pages/support/management/users/Users";
import { ErrorPageNotFound } from "../pages/error/PageNotFound";
import { NewUser } from "../pages/support/management/users/NewUser";
import { Dashboard } from "../pages/support/dashboard/Dashboard";
import { Stores } from "../pages/support/management/stores/Stores";
import { Owners } from "../pages/support/management/owners/Owners";
import { NewStore } from "../pages/support/management/stores/NewStore";
import { NewOwner } from "../pages/support/management/owners/NewOwner";
import { StoreGroups } from "../pages/support/management/storeGroups/StoreGroups";
import { NewStoreGroup } from "pages/support/management/storeGroups/NewStoreGroup";
import { AdvancedMultiStore } from "pages/support/management/multistore/AdvancedMultiStore";
import { SimpleMultiStore } from "pages/support/management/multistore/SimpleMultiStore";
import { Conflicts } from "pages/support/analytics/Conflicts";

export function SupportRoutes() {
    const loggedIn = isLoggedIn();
    return (
        <div>
            <Layout>
                <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    {/* Analytics */}
                    <Route path="/conflicts" element={<Conflicts />} />
                    {/* Owners */}
                    <Route path="/owners" element={<Owners />} />
                    <Route path="/owner/:ownerId?" element={<NewOwner />} />
                    {/* Store Groups */}
                    <Route path="/storegroups" element={<StoreGroups />} />
                    <Route path="/storegroup/new" element={<NewStoreGroup />} />
                    <Route path="/storegroup/:storeGroupId" element={<NewStoreGroup />} />
                    {/* Users */}
                    <Route path="/users" element={<Users />} />
                    <Route path="/user/new" element={<NewUser />} />
                    <Route path="/user/:userId" element={<NewUser />} />
                    {/* Stores */}
                    <Route path="/stores" element={<Stores />} />
                    <Route path="/store/new" element={<NewStore />} />
                    <Route path="/store/:storeId" element={<NewStore />} />
                    <Route path="/*" element={<ErrorPageNotFound />} />
                    {/* Multistore */}
                    <Route path="/multistore/advanced" element={<AdvancedMultiStore />} />
                    <Route path="/multistore/simple" element={<SimpleMultiStore />} />
                </Routes>
            </Layout>
        </div>
    );
}